import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth Client
 * 
 * Provides authentication methods and hooks for the React frontend
 */

const isProduction = import.meta.env.PROD;

export const authClient = createAuthClient({
  // In production, use relative path so requests go through Vercel proxy (first-party cookies)
  // In development, use VITE_API_URL (direct to local backend)
  baseURL: isProduction ? '' : (import.meta.env.VITE_API_URL || 'http://localhost:3001'),
  fetchOptions: {
    credentials: 'include',
  },
});

// Re-export hooks for convenience
export const { useSession, signIn, signUp, signOut } = authClient;

// Type exports
export type Session = Awaited<ReturnType<typeof authClient.getSession>>['data'];
export type User = NonNullable<Session>['user'];
